const routes = [
  {
    path: "/recipes",
    name: "MyRecipes",
    component: () =>
      import(
        /* webpackChunkName: "myrecipes" */ "@/pages/MyRecipes/MyRecipesIndex"
      ),
    meta: {
      title: "MyRecipes - NutriBit",
      showSearch: true
    }
  }
];

export default routes;
